import { Box, alpha } from '@mui/material';
import { styled } from '@mui/material/styles';

const StyledBox = styled(Box)(({ theme }) => ({
  position: 'relative',
  '& .CUHero': {
    position: 'relative',
    paddingTop: theme.spacing(10),
    paddingBottom: theme.spacing(8),
    [theme.breakpoints.down('md')]: {
      paddingTop: theme.spacing(8),
      paddingBottom: theme.spacing(5),
    },
  },
  '& .CUHeroContent': {
    marginTop: theme.spacing(15),
    [theme.breakpoints.down('md')]: {
      marginTop: theme.spacing(5),
    },
  },
  '& .CUHero .MuiContainer-root': {
    [theme.breakpoints.only('md')]: {
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2),
    },
  },
  '& .CUHeroBGContainer': {
    position: 'absolute',
    left: 0,
    right: 0,
    top: 0,
    zIndex: 0,
    height: '100vh',
    '&:after': {
      content: '""',
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: 0,
      height: '80%',
      zIndex: 1,
      background: `linear-gradient(to top, ${theme.palette.background.primary} 0%, transparent 100%)`,
    },
  },
  '& .CUBGPattern': {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    height: '100%',
    zIndex: 2,
    maskImage: `linear-gradient(
      to bottom,
       ${alpha(theme.palette.common.black, 0.4)} 50%,
       ${alpha(theme.palette.common.black, 0.01)} 100%
    )`,
  },
  '& .CUInner': {
    position: 'relative',
    zIndex: 2,
    margin: '0 auto',
  },
}));

export default StyledBox;

